import axiosClient from './axiosClient';

const adminLogService = {
    getAll: async (params = {}) => {
        const response = await axiosClient.get('/admin/logs', { params });
        return response.data;
    }
};

export default adminLogService;
